import { inject } from "@angular/core";
import { IStep } from "../interfaces/IStep";
import { GlobalConfigService } from "../../../core/services/global-config.service";


export class StepByStep {

  static steps: IStep[] = [
    {
      title: 'Faça seu cadastro na plataforma ',
      description: 'Ao acessar o formulário de cadastro da Broadfactor <b>AntecipaGov</b>, preencha os dados solicitados para concluir seu registro  ',
      imageUrl: 'assets/images/home/register.png',
      number: 1
    },
    {
      title: `Acesse o portal <a href="https://antecipagov.comprasnet.gov.br/" target="_blank" >AntecipaGov</a>`,
      description: 'Acesse o portal do Governo,  faça login com o GOV.BR e faça sua solicitação de valor',
      imageUrl: 'assets/images/home/access_antecipagov.png',
      number: 2
    },
    {
      title: 'Aguarde nosso contato',
      description: 'Um consultor Broadfactor entrará em contato com você em breve para continuar o processo',
      imageUrl: 'assets/images/home/telemarketing.png',
      number: 3
    },
    {
      title: 'Disponibilização de propostas',
      description: 'Após a análise, uma ou mais propostas de crédito estarão disponíveis no portal AntecipaGov para seu aceite',
      imageUrl: 'assets/images/home/check.png',
      number: 4
    },
    {
      title: 'Liberação de recursos',
      description: 'Com a proposta aceita e documentos assinados digitalmente, o recurso será transferido para conta da sua empresa',
      imageUrl: 'assets/images/home/money.png',
      number: 5
    }
  ]
}
